export const getExistingTaxosInItems = (data) => {
  const existingTaxosInItems = data
    .map(({ node }) => {
      return node.relationships.field_taxonomie_thematique.map((element) => {
        return element.name
      })
    })
    .reduce((acc, currentValue) => {
      acc.push(...currentValue)
      return acc
    })
  const relatedTaxos = [...new Set(existingTaxosInItems)]
  return relatedTaxos
}
